const sysparameterByNames = Object.freeze({
  CanSignPeiDate: 'CanSignPeiDate',
  PeiShutdownDate: 'PeiShutdownDate',
  EnableBillingAdjustmentStatus: 'EnableBillingAdjustmentStatus',
  PlanShutdownDate: 'PlanShutdownDate',
  CompensatoryIsExceptionAcademicYear: 'CompensatoryIsExceptionAcademicYear',
  AddViewInterventionPlanToFutureYear: 'AddViewInterventionPlanToFutureYear',
  DisbursementSendToProvider: 'DisbursementSendToProvider',
  ReferralResultSummary: 'ReferralResultSummary',
  ProvisionalRemedyProposalDocumentRequired:
    'ProvisionalRemedyProposalDocumentRequired',
  AcademicYearDownloadRefundCertificationReport:
    'AcademicYearDownloadRefundCertificationReport',
  ExclusiveAcademicYearsForDisbursementCertificationValidation:
    'ExclusiveAcademicYearsForDisbursementCertificationValidation',
  SpecialistAvailabilityCalendarPilot:
    'ProviderSpecialistAvailabilityCalendarPilot',
  CanCreateDEPRSpecialistsOtherCorporations:
    'CanCreateDEPRSpecialistsOtherCorporations',
  DirectPaymentSifde: 'DirectPaymentSifde',
  StartDateDirectPaymentRequest: 'StartDateDirectPaymentRequest',
  DEPRCompanyId: 'DEPRCompanyId',
  ExtendedAcademicYear: 'ExtendedAcademicYearDateRange',
  LastSchoolDate: 'LastSchoolDate',
  BlockRegularVisitsRegistryDuringAEE: 'BlockRegularVisitsRegistryDuringAEE',
  ResultSummaryFeatureImprovementEnabled:
    'ResultSummaryFeatureImprovementEnabled',
  RegressionExtendedAcademicYearDateRange:
    'RegressionExtendedAcademicYearDateRange',
  ReplenishmentExtendedAcademicYearDateRange:
    'ReplenishmentExtendedAcademicYearDateRange',
  ActiveSignHub: 'ActiveSignHub',
  AcademicYearAchievementSummarySignHubAllow:
    'AcademicYearAchievementSummarySignHubAllow',
  InverteventionPlanAreaSelection: 'InverteventionPlanAreaSelection',
  MedicaidDocumentationWorkflowEnabled: 'MedicaidDocumentationWorkflowEnabled',
  CanAddDiagnosis: 'CanAddDiagnosis',
  ElectronicTransferJornalPayment: 'ElectronicTransferJornalPayment',
  MedicaidPilotCompanyIds: 'MedicaidPilotCompanyIds',
});

export default sysparameterByNames;
